// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__3KIZY","navColor":"Header_navColor__35PoY","stopscroll":"Header_stopscroll__2jRX-","navContainer":"Header_navContainer__2Rzrm"};